import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UserService} from '../../../services/user.service';
import {MessageService} from '../chat/message.service';
import {HttpClient} from '@angular/common/http';
import {StepsControllerService} from '../../../services/steps-controller.service';
import {AdminService} from '../../../services/admin.service';
import * as moment from 'moment';
import {TestingProcessService} from './testing-action/testing-process.service';
import {ApiConnectService} from '../../../services/api-connect.service';
import {NotificationsService} from '../../../services/notifications.service';
import {LanguageSwitcher} from '../../../header/language-switcher/language-switcher.model';
import {SuggestionListsService} from '../../common/suggestion-lists/services/suggestion-lists.service';
import {ViewDocxComponent} from '../../views/view-docx/view-docx.component';
import {ViewDocxService} from '../../../services/view-docx.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-user-familiarize-standard',
  templateUrl: './user-familiarize-standard.component.html',
  styleUrls: ['./user-familiarize-standard.component.css'],
  providers: [LanguageSwitcher]
})
export class UserFamiliarizeStandardComponent implements OnInit, OnDestroy {
  @ViewChild('spanList') el:ElementRef;
  testingLoad = false;
  isClicked = false;
  isLoaded = false;
  public standardId: string;
  standard: any;
  stringDate: string;
  nextTwoBtn = false; // familiarizationDate
  nextModificationBtn = false;
  nextApprovedBtn = false;
  ftwoError = false;
  testingIsDone = false;
  canFam = false;
  cUserName = '';
  cUserID = null;
  cUser: any;
  showInputMessage: boolean;
  public userLanguage: string;
  isLoadedFamiliarize = true;
  changeLogs;
  showLogs = false;
  type;

  constructor(private route: ActivatedRoute,
              private http: HttpClient,
              private router: Router,
              public viewDocxService: ViewDocxService,
              private modalService: NgbModal,
              private notificationsService: NotificationsService,
              private adminService: AdminService,
              private userService: UserService,
              private apiConnectService: ApiConnectService,
              private stepsControllerService: StepsControllerService,
              public messageService: MessageService,
              public testingProcessService: TestingProcessService,
              public languageSwitcher: LanguageSwitcher,
              private suggestionListsService: SuggestionListsService) {
  }


  ngOnDestroy() {
    this.stepsControllerService.setLogsID(null);
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.standardId = params['id'];
      this.isLoaded = false;
      this.getFamStandard();
      this.getChangeLog();
      this.checkType();
    });
  }

  checkType(){
    this.type = localStorage.getItem('standartType');
  }

  getChangeLog(){
    this.adminService.getChangeLogs(this.standardId).subscribe(
      (res: any) => {
        if (res.status === 200) {
          this.changeLogs = res.body.reverse();
          this.isLoaded = true;
        }
      },
      () => {
        this.isLoaded = true;
      }
    );
  }

  confirm() {
    this.isClicked = true;
    let obj = JSON.parse(localStorage.getItem('notificationCategory'));
    this.adminService.notifyIsViewNot(obj).subscribe(
      (response: any) => {
        localStorage.removeItem('notificationCategory');
        this.router.navigate(['/dashboard']);
      },
      () => {
      }
    );
  }

  getFamStandard() {
    this.testingProcessService.successMsg = false;
    // Data
    this.stringDate = moment().format('DD.MM.YYYY');
    this.standardId = this.route.snapshot.params['id'];

    this.stepsControllerService.setLogsID(this.standardId);

    this.userService.getSelf().subscribe(
      (res: any) => {
        this.cUser = res.body;
        this.cUserID = res.body.id;
        this.cUserName = res.body.firstName + ' ' + res.body.lastName;
        this.userLanguage = this.cUser.language;
      },
      () => {
      }
    );

    // get standard;
    this.adminService.getStandard(this.standardId).subscribe(
      (response: any) => {
        this.standard = response.body;

        if (this.router.url.includes('ex-notification-familiarize-action/')) {
          this.stepsControllerService.setCurrentStandard(this.standard);
        }

        this.testingProcessService.setStandard(this.standard);

        // Показывать ли тестирование
        this.testingProcessService.showTesting = this.standard.status === 'ACTIVE';

        this.messageService.setTempStandard(this.standard);

        // Get familiarize info:
        this.stepsControllerService.getFamiliarizedInfo(this.standardId).subscribe(
          (res: any) => {
            const tableUsers = res.body;
            let tempMe: any;
            for (const item of tableUsers) {
              if (item.user.id === this.cUser.id) {
                tempMe = item;
                this.isLoaded = true;
                break;
              }

            }
            this.isLoaded = true;
            // If user is familiarized
            if (tempMe.acknowledgementDate !== '' && tempMe.acknowledgementDate !== undefined) {
              this.nextTwoBtn = true;
            } else {
              this.nextTwoBtn = false;
            }

            // Wait for the standard modification.
            if (tempMe.modificationRequestDate !== '') {
              this.nextModificationBtn = true;
              this.nextApprovedBtn = false;
            }

            // You have approved this standard.
            if (tempMe.confirmationDate !== '') {
              this.nextModificationBtn = false;
              this.nextApprovedBtn = true;
            }

            if (tempMe.testingDate !== '' && tempMe.testingDate !== null) {
              this.testingProcessService.showTesting = false;
              this.testingIsDone = true;
            }

            this.isLoaded = true;
          },
          (error) => {
            this.isLoaded = true;
          }
        );
      },
      (error) => {
        this.isLoaded = true;
      }
    );
  }

  openPdfStnd(fileId: string) {
    window.open(this.apiConnectService.getPdf + fileId, '_blank');
  }


  openDocModal(docxID, sID) {
    localStorage.setItem('DocxID', docxID);
    localStorage.setItem('DocxSID', sID);

    const modalRef = this.modalService.open(ViewDocxComponent, {size: 'lg', backdrop: 'static'});
    modalRef.result.then((result) => {
      if (result === 'Close') {
        // on close button
        this.viewDocxService.deleteLinkByDocxID();
      }
    }, (reason) => {
      // on dismiss
      this.viewDocxService.deleteLinkByDocxID();
    });

  }


  openDocModalDOCX(fileLink) {
    localStorage.setItem('fileLink', fileLink);

    const modalRef = this.modalService.open(ViewDocxComponent, {size: 'lg', backdrop: 'static'});
    modalRef.result.then((result) => {
      if (result === 'Close') {
        // on close button
        this.viewDocxService.deleteLinkByDocxIDManually();
      }
    }, (reason) => {
      // on dismiss
      this.viewDocxService.deleteLinkByDocxIDManually();
    });

  }


  downloadFile(id) {
    this.userService.getFile(id).subscribe(
      (response: any) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.body);
        link.download = response.headers.get('filename');
        link.click();
        link.remove();
      },
      () => {
      }, () => {
      }
    );

  }

  familiarizeWithStandard() {
    this.ftwoError = false;
    this.isLoadedFamiliarize = false;
    this.userService.doFamiliarizeWithStandard(this.standard.id).subscribe(
      (response: any) => {
        this.isLoadedFamiliarize = true;

        this.nextTwoBtn = true;
        this.notificationsService.getNearNotificationFromAPI();
        this.goToExNotifList();
      },
      () => {
        this.isLoadedFamiliarize = true;
      }
    );
  }

  goToExNotifList() {
    if (this.router.url.includes('ex-notification-familiarize-action/')) {
      this.router.navigate(['/ex-notifications']);
    }
  }

  approved() {
    this.userService.doApproved(this.standard.id).subscribe(
      (response: any) => {
        this.nextModificationBtn = false;
        this.nextApprovedBtn = true;
      },
      () => {
      }
    );
  }

  requiresModification() {
    this.userService.doRequiresModification(this.standard.id).subscribe(
      (response: any) => {
        this.nextModificationBtn = true;
        this.nextApprovedBtn = false;
      },
      () => {
      }
    );
  }

  addNewSL() {
    this.suggestionListsService.setListType('standard');
    this.suggestionListsService.setStandard(this.standard);
    this.router.navigate(['/dashboard/create-suggestion-list']);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/operating-standard/user-familiarize-standard/user-familiarize-standard.component.ts